import { makeAutoObservable } from "mobx";
import adminAuthService from "../services/authService";

class clientsStore {
  user = {};
  planTypeMetrics = [];
  agents = [];
  zeroToOne = {
    clientMetrics: {},
    all: [],
    totalAssigned: [],
    submittedForApproval: [],
    adminApproved: [],
    sharedWithClient: [],
    locked: [],
  };
  basic = {
    clientMetrics: {},
    all: [],
    totalAssigned: [],
    submittedForApproval: [],
    adminApproved: [],
    sharedWithClient: [],
    locked: [],
  };
  comprehensive = {
    clientMetrics: {},
    all: [],
    totalAssigned: [],
    submittedForApproval: [],
    adminApproved: [],
    sharedWithClient: [],
    locked: [],
  };
  wealthManagement = {
    clientMetrics: {},
    all: [],
    totalAssigned: [],
    submittedForApproval: [],
    adminApproved: [],
    sharedWithClient: [],
    locked: [],
  };

  // selectedAwaken = null;
  // currentStatus = "";

  // constructor() {
  //   makeAutoObservable(this);
  //   this.setSelectedAwaken = this.setSelectedAwaken.bind(this);
  //   this.setCurrentStatus = this.setCurrentStatus.bind(this);
  // }
  // setSelectedAwaken(awaken) {
  //   this.selectedAwaken = awaken;
  // }

  // setCurrentStatus(status) {
  //   this.currentStatus = status;
  // }

  setUserData(data) {
    this.user = data || {};
    
    if (data) {
      // Store in both localStorage and sessionStorage for compatibility
      this.saveToLocalStorage("user", data);
      this.saveToLocalStorage("admin_user", data);
    } else {
      // Clear user data on logout
      localStorage.removeItem("user");
      localStorage.removeItem("admin_user");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("admin_user");
    }
  }

  saveToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    // Also save to sessionStorage for JWT compatibility
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getAgentsFromLocalStorage() {
    const agents = localStorage.getItem("agents");
    this.agents = agents ? JSON.parse(agents) : [];
  }

  getFromLocalStorage() {
    // Try to get user from auth service first
    const authUser = adminAuthService.getCurrentUser();
    if (authUser) {
      this.user = authUser;
      return;
    }
    
    // Fallback to localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    this.user = user ? user : null;
  }

  setPlanTypeMetrics(data) {
    this.planTypeMetrics = [];
    if (data.length === 0) {
      return;
    }
    const planTypes = [
      "basic",
      "comprehensive",
      "zeroToOne",
      "wealthManagement",
    ];
    planTypes?.forEach((planType) => {
      const planTypeData = data?.filter(
        (element) => element.planType === planType
      );
      console.log(planType, "planTypeData", JSON.stringify(planTypeData));
      this.planTypeMetrics.push({
        planType: planType,
        count: planTypeData[0]?.count,
      });
    });
  }

  setAgents(data) {
    this.agents = data;
    this.saveToLocalStorage("agents", data);
  }

  setClientsData(data, planType, status) {
    if (data && data.data) {
      this[planType].clientMetrics = data.clientMetrics;
      this[planType][status] = data.data;
    } else {
      console.error("Invalid data format for clients", data);
    }
  }

  setClientsDataByStatus(allStatusData,metrics, planType) {
    if (allStatusData) {
      this[planType].clientMetrics = metrics;
      for(const key in allStatusData){
        this[planType][key] = allStatusData[key];
      }
    } else {
      console.error("Invalid data format for clients", allStatusData);
    }
  }

  setFormattedDate(date) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(date)
      .toLocaleDateString("en-US", options)
      .replace(",", "");
    return formattedDate;
  }

  camelToTitleCase(camelCaseString) {
    // Split the camel case string into words
    if (!camelCaseString) {
      return "";
    }
    
    // Special case for zeroToOne to return Zero2One
    if (camelCaseString === "zeroToOne") {
      return "Zero2One";
    }
    
    // Special case for wealthManagement to return Wealth
    if (camelCaseString === "wealthManagement") {
      return "Wealth";
    }
    
    const words = camelCaseString.replace(/([A-Z])/g, " $1").split(" ");

    // Capitalize the first letter of each word and join them with spaces
    const titleCaseString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return titleCaseString;
  }

  normalizePlanType(planType) {
    // Normalize planType from various formats (Zero2One, zerotoone, etc.) to camelCase (zeroToOne)
    if (!planType) {
      return "";
    }
    
    // Convert to lowercase first for case-insensitive matching
    const lowerPlanType = planType.toLowerCase();
    
    // Handle Zero2One variations
    if (lowerPlanType === "zero2one" || lowerPlanType === "zerotoone" || lowerPlanType === "zero-to-one") {
      return "zeroToOne";
    }
    
    // Handle wealthManagement variations
    if (lowerPlanType === "wealthmanagement" || lowerPlanType === "wealth-management") {
      return "wealthManagement";
    }
    
    // For other plan types, return as-is if already camelCase, or convert common formats
    // If it's already camelCase (has lowercase followed by uppercase), return as-is
    if (/^[a-z]+[A-Z]/.test(planType)) {
      return planType;
    }
    
    // If it's all lowercase and matches known plan types, return as-is
    const knownPlanTypes = ["basic", "comprehensive", "term", "health", "pension"];
    if (knownPlanTypes.includes(lowerPlanType)) {
      return lowerPlanType;
    }
    
    // Default: return lowercase version
    return lowerPlanType;
  }

  constructor() {
    makeAutoObservable(this);
    this.initializeData();
    this.getAgentsFromLocalStorage();
    this.getFromLocalStorage();
  }
  initializeData() {
    this.totalAssignedData = [
      {
        sno: "01",
        financialPlanner: "RajeshBirlangi",
        client: "Raju",
        createdOn: "11-Jan-2024",
        allocatedOn: "Ramu",
      },
      {
        sno: "02",
        financialPlanner: "Shaker",
        client: "Rajukumar",
        createdOn: "13-Jan-2024",
        allocatedOn: "RamuKanc",
      },
      {
        sno: "03",
        financialPlanner: "Sai",
        client: "Suresh",
        createdOn: "15-Jan-2024",
        allocatedOn: "Mahesh",
      },
    ];

    this.submittedApprovalData = [
      {
        sno: "01",
        financialPlanner: "RajeshBirlangi",
        client: "Raju",
        createdOn: "11-Jan-2024",
        status: "Evaluate",
      },
      {
        sno: "02",
        financialPlanner: "Shaker",
        client: "Rajukumar",
        createdOn: "13-Jan-2024",
        status: "Evaluate",
      },
      {
        sno: "03",
        financialPlanner: "Sai",
        client: "Suresh",
        createdOn: "15-Jan-2024",
        status: "Evaluate",
      },
    ];

    this.approvalBySuperFinancialPlanner = [
      {
        sno: "01",
        financialPlanner: "RajeshBirlangi",
        client: "Raju",
        createdOn: "11-Jan-2024",
        status: "Send Report to the Client",
      },
      {
        sno: "02",
        financialPlanner: "Shaker",
        client: "Rajukumar",
        createdOn: "13-Jan-2024",
        status: "Send Report to the Client",
      },
      {
        sno: "03",
        financialPlanner: "Sai",
        client: "Suresh",
        createdOn: "15-Jan-2024",
        status: "Send Report to the Client",
      },
    ];

    this.sharedWithClient = [
      {
        sno: "01",
        financialPlanner: "RajeshBirlangi",
        client: "Raju",
        createdOn: "11-Jan-2024",
        status: "Waiting for Clients Approval",
      },
      {
        sno: "02",
        financialPlanner: "Shaker",
        client: "Rajukumar",
        createdOn: "13-Jan-2024",
        status: "Waiting for Clients Approval",
      },
      {
        sno: "03",
        financialPlanner: "Sai",
        client: "Suresh",
        createdOn: "15-Jan-2024",
        status: "Waiting for Clients Approval",
      },
    ];

    this.lockedAwakens = [
      {
        sno: "01",
        financialPlanner: "RajeshBirlangi",
        client: "Raju",
        createdOn: "11-Jan-2024",
        status: "View Report",
      },
      {
        sno: "02",
        financialPlanner: "Shaker",
        client: "Rajukumar",
        createdOn: "13-Jan-2024",
        status: "View Report",
      },
      {
        sno: "03",
        financialPlanner: "Sai",
        client: "Suresh",
        createdOn: "15-Jan-2024",
        status: "View Report",
      },
    ];
  }
}

export default clientsStore;
